import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import emitter from "@utils/emitter";
import dynamic from "next/dynamic";
import { MixpanelEvent } from "@modules/home/components/MixpanelEvent";

const PopupLayout = dynamic(
    () => import("@modules/home/components").then((mod) => mod.PopupLayout),
    {
        ssr: false,
    },
);

export const WAIT_DELAY =
    parseInt(process.env.NEXT_PUBLIC_SKELETON_WAIT_DELAY ?? "30") * 1000;

export const withShowRetryPopup = (func: () => Promise<any>, src: string) => {
    let interval = setInterval(() => {
        emitter.emit("show_retry_popup", {
            source: src,
            id: "timeout",
        });
    }, WAIT_DELAY);
    func().then(() => {
        clearInterval(interval);
        // @ts-ignore
        interval = null;
    });
};

export const withHideRetryPopup = (res: any, src: string) => {
    emitter.emit("hide_retry_popup");
    MixpanelEvent.track("retry_popup_hidden", {
        source: src,
    });
    return res;
};

const RetryGuard = (props: any) => {
    const [showRetry, setShowRetry] = useState(false);
    const [event, setEvent] = useState(null);
    const router = useRouter();

    useEffect(() => {
        const onShowRetryPopup = (data: any) => {
            const div =
                document.getElementsByClassName(
                    "bottomSheetDialog quiz-header-container",
                ) ?? [];
            if (div.length > 0) return;

            setShowRetry(true);
            setEvent(data);
            MixpanelEvent.track("retry_popup_visible", {
                source: data.source ?? "",
                source_id: data.id ?? "",
            });
        };
        const onHideRetryPopup = () => {
            setShowRetry(false);
        };
        emitter.on("show_retry_popup", onShowRetryPopup);
        emitter.on("hide_retry_popup", onHideRetryPopup);
        return () => {
            emitter.off("show_retry_popup", onShowRetryPopup);
            emitter.off("hide_retry_popup", onHideRetryPopup);
        };
    }, []);

    return (
        <>
            {showRetry && (
                <div>
                    <PopupLayout
                        showBottomSheet={true}
                        setShowBottomSheet={() => {
                            // handleClose(false);
                        }}
                        icon={
                            "https://cdn.homeworkapp.ai/sets-gamify-assets/math-ai-assets/assets/animations/no-internet.json"
                        }
                        title={"Something went wrong!"}
                        description={"Please try again."}
                        hasSecondary={false}
                        primaryText={"Try Again!"}
                        primaryClick={() => {
                            setShowRetry(false);
                            router.reload();
                            MixpanelEvent.track("retry_popup_click", {
                                action: "reload",
                                ...(event ?? {}),
                            });
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default RetryGuard;
